import { render, staticRenderFns } from "./document-number-structure-example.vue?vue&type=template&id=6243f963&"
import script from "./document-number-structure-example.vue?vue&type=script&lang=ts&"
export * from "./document-number-structure-example.vue?vue&type=script&lang=ts&"
import style0 from "./document-number-structure-example.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports